import { AllGeoJSON } from "@turf/helpers";
import { MapMouseEvent, MapTouchEvent } from "maplibre-gl";

export type Feature = Extract<AllGeoJSON, { type: "Feature"; }>;
export type FeatureCollection = Extract<AllGeoJSON, { type: "FeatureCollection"; }>;
export type PolygonTypes = Extract<AllGeoJSON, { type: "Polygon" | "MultiPolygon"; }>;

export enum Positions {
    TOP_LEFT = 'top-left',
    TOP_RIGHT = 'top-right',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_RIGHT = 'bottom-right',
    TOP = 'top',
    BOTTOM = 'bottom',
}


export type PopupDefinition = {
    element: HTMLElement;
    onShow: (e: MapMouseEvent | MapTouchEvent) => boolean;
    onHide: (e: MapMouseEvent | MapTouchEvent) => void;
};

export type MapSettings = {
    style?: string;
    //TODO: expand according to requirements
};